export const SUPPORTS_OBJECT_IS_EXTENSIBLE = "isExtensible" in Object;
